import HeaderScrolled from '../../../helper/header-scrolled';
import ScrollTo from '../../../helper/scroll-to';

const HomeBlog = {
  init() {
    this._scrollToInit();
    this._headerScrolledInit();
  },


  _scrollToInit() {
    ScrollTo.init();
  },


  _headerScrolledInit() {
    HeaderScrolled.init();
  }
};

export default HomeBlog;